import React from 'react';
import VideoSlide from '../body/VideoSlide';

export const WelcomeVideo = ({ setVideoWatched }) => {
  return (
    <VideoSlide
      onEnd={setVideoWatched ? setVideoWatched : undefined}
      vidSrc={1198793103}
    />
  );
};

export const WelcomeVideoNoLoading = () => {
  return (
    <div className='p-6'>
      <div className='max-w-5xl mx-auto'>
        <VideoSlide vidSrc={1216264139} />
      </div>
    </div>
  );
};
